module.exports = __webpack_public_path__ + "media/images/brands/pakalolo-2a8e67f7c466fba7b46e9557ec5ef513.png";